import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { CssVars, FoundationIcon, SemanticColorToken } from '@robinhood/design';
import { Type, getStylesForTextType } from '@robinhood/design/product/components/Type';
import { InternalInput, InternalInputProps } from '@robinhood/design/product/components/internal/InternalInput';

interface TextInputProps extends InternalInputProps {
  error?: string;
  disabled?: boolean;
}

const TextInput = ({ disabled, ...props }: TextInputProps) => {
  const overrideRootStyles = React.useMemo<CSSInterpolation>(() => {
    const borderStyle =
      props.state == 'default' || props.state == undefined
        ? {
            '&:focus-within': {
              borderColor: CssVars.semantic.positive.base,
            },
          }
        : {};

    return {
      borderRadius: '12px',
      height: '56px',
      paddingLeft: '24px',
      paddingRight: '24px',
      ...borderStyle,
      backgroundColor: CssVars.neutral.bg2,
      width: '100%',
    };
  }, [props.state]);

  return (
    <div css={root}>
      <InternalInput
        {...props}
        state={disabled ? 'disabled' : props.state}
        endControl={disabled ? <FoundationIcon type='Lock16' /> : props.endControl}
        overrideRootStyles={[overrideRootStyles, props.overrideRootStyles]}
        overrideInputStyles={[getStylesForTextType({ size: 'M' }), props.overrideInputStyles]}
      />
      {props.error && (
        <Type.Text size='S' color={SemanticColorToken.Error}>
          {props.error}
        </Type.Text>
      )}
    </div>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default TextInput;
